<template>
    <div class="my-10">
        <div class="flex flex-col">

            <h1 class="font-bold text-2xl">{{ $t('nav.faq') }}</h1>
            <div class="flex flex-col">
                <Accordion v-for="(qa, idx) in qas" :key="idx" :label="qa.question">
                    <p v-html="qa.answer"></p>
                </Accordion>
            </div>
        </div>
    </div>
</template>

<script>
import api from '@/api';
import Accordion from '@cmp/Accordion.vue'

export default {
    name: 'faq',
    components: {
        Accordion
    },
    data(){
        return {
            loading: false,
            qas: []
        }
    },
    methods: {
        async getFaq(){
            this.loading = true
            try{ 
                const response = await api.get('qa/')
                this.qas = response.data
            }
            catch(e){
                console.log(e)
            }
            this.loading = false

        }
    },
    computed: {

    },
    async created(){
        await this.getFaq()
    }
}

</script>